import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errorMessage } from "@/lib/api";
import { formatDate } from "@/lib/services";
import { useServices } from "@/context/ServicesContext";
import { ArchivedItem } from "@/components/app/ArchivedItem";
import { DayDialog } from "@/components/app/DayDialog";

export const ArchivedView = ({ version, onChanged }) => {
  const { today } = useServices();
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [dialog, setDialog] = useState(null);

  const load = useCallback(() => {
    api.get("/archived", { params: { today } }).then((r) => setItems(r.data)).catch((e) => toast.error(errorMessage(e)));
  }, [today]);
  useEffect(() => { load(); }, [load, version]);

  const done = (msg) => { toast.success(msg); load(); onChanged(); };

  const onAct = (s, kind) => setDialog(kind === "reschedule" ? {
    title: "Reagendar atendimento", submitLabel: "Reagendar",
    description: `${s.client_name} · ${s.service_name}. Volta para o calendário e para o planejamento na nova data.`,
    dateLabel: "Nova data do atendimento",
    onSubmit: async ({ on }) => { await api.post(`/services/${s.id}/reschedule`, { on }); done(`Reagendado para ${formatDate(on)}.`); },
  } : {
    title: "Lembrar de tentar de novo", submitLabel: "Salvar lembrete",
    description: `${s.client_name} continua arquivado e fica em destaque nesta lista na data escolhida.`,
    dateLabel: "Tentar de novo em",
    onSubmit: async ({ on }) => { await api.post(`/services/${s.id}/archive-reminder`, { on }); done(`Lembrete marcado para ${formatDate(on)}.`); },
  });

  const list = (items || []).filter((s) => s.client_name.toLowerCase().includes(q.trim().toLowerCase()));
  const due = list.filter((s) => s.reminder_due).length;

  return (
    <section className="space-y-4" data-testid="archived-view">
      <div className="flex flex-col gap-3 rounded-xl border border-slate-700/60 bg-slate-900/60 p-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-display text-lg font-bold">Arquivados sem retorno <span className="font-mono text-sm text-slate-500" data-testid="archived-count">({list.length})</span></h2>
          <p className="text-xs text-slate-400">Serviços atrasados de clientes que não responderam. Tente de novo, reagende ou marque um lembrete.{due > 0 && <b className="text-amber-300"> {due} lembrete(s) para hoje.</b>}</p>
        </div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cliente" className="h-10 bg-slate-900 sm:w-56" data-testid="archived-search-input" />
      </div>
      {items && list.length === 0 ? (
        <p className="rounded-xl border border-dashed border-slate-700 py-10 text-center text-sm text-slate-500" data-testid="archived-empty">Nenhum serviço arquivado. Use “Arquivar” nos atrasados do Planejamento.</p>
      ) : (
        <ul className="grid gap-3 lg:grid-cols-2">{list.map((s) => <ArchivedItem key={s.id} s={s} onAct={onAct} />)}</ul>
      )}
      <DayDialog state={dialog} onClose={() => setDialog(null)} />
    </section>
  );
};
